import { FC } from 'react'
import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
} from 'react-admin'
import { Typography, Box } from '@mui/material'
import { xxllncColor } from '../../layout/themes'

export const EmployeeShow: FC = () => (
  <Show>
    <SimpleShowLayout>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          sx={{ color: xxllncColor.mineShaft, fontWeight: 'bold' }}
        >
          Medewerker Details
        </Typography>
      </Box>

      <TextField source="name" label="Naam" />
      <TextField source="email" label="E-mail" />
      <TextField source="department" label="Afdeling" />
      <TextField source="role" label="Rol" />
      <BooleanField source="is_active" label="Actief" />
    </SimpleShowLayout>
  </Show>
)
